const config: Record<any, any> = {
	lng: 'vi', //vi|en
	region: 'VI', //vi|pk
	version: '1',
	statusSuccess: 'successful',
	domain: 'b2s.fconline.garena.vn',
	baseUrl: 'https://b2s.fconline.garena.vn/',
	downloadUrl: '',
	dailySpinMission: { name: 'Chơi 1 trận XH, GLXH, Volta live (tích lũy tối đa 4 lần)', max: 4 },
	eventMsg: 'Sự kiện sẽ bắt đầu vào ngày 03.09.2026',
	shareHashtag: 'BacktoschoolFCO #FCOnline',
	shareQuote: '',
	predictGuide: 'https://',
	prizeListGlobal:
		'https://cdn.vn.garenanow.com/web/fo4vn//Khoa/2024/T9/EPL/epl_qua.png',
	guideImg:
		'https://cdn.vn.garenanow.com/web/fo4vn//Khoa/2024/T9/EPL/epl_hdc.png',
	microsoftLoginUrl: '/api/user/verify-microsoft-login',
	googleLoginUrl: '/api/user/verify-google-login',
};
export default config;
